import React, { createContext, useContext, useEffect, useState } from 'react';
import { saveToLocal, getFromLocal, clearFromLocal } from '../utils/pageSessionUtils';

const PageSessionContext = createContext();

export const PageSessionProvider = ({ children }) => {
  const [sessionData, setSessionData] = useState({});

  useEffect(() => {
    const stored = getFromLocal();
    setSessionData(stored);
  }, []);

  const updateSession = (newData = {}) => {
    const updated = { ...sessionData, ...newData };
    setSessionData(updated);
    saveToLocal(updated);
  };

  const removeKeys = (keys = []) => {
    const updated = { ...sessionData };
    keys.forEach((key) => delete updated[key]);
    setSessionData(updated);
    saveToLocal(updated);
  };

  const resetSession = () => {
    setSessionData({});
    clearFromLocal();
  };

  return (
    <PageSessionContext.Provider value={{ sessionData, updateSession, removeKeys, resetSession }}>
      {children}
    </PageSessionContext.Provider>
  );
};

export const usePageSession = () => useContext(PageSessionContext);
